/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './Boleto25DDA.css';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function Boleto25DDA() {
  return (
    <>
      <section id="boleto-dda">
        <ContainerHome24>
          <h3 className="boleto-dda-titulo">Simplifique sua vida financeira com o DDA</h3>
          <p className="boleto-dda-subtitulo">
            Com o DDA, você pode utilizar consultar todos os boletos que estão em seu nome no
            aplicativo de seu banco.
          </p>
          <div className="boleto-dda-cards">
            <div className="boleto-dda-card">
              <img src="assets/boleto25/ic_mobile.svg" alt="" className="boleto-dda-card-img" />
              <p className="boleto-dda-card-text">
                Você pode organizar suas contas mensais em um lugar só.
              </p>
            </div>
            <div className="boleto-dda-card">
              <img
                src="assets/boleto25/ic_calendar_check.svg"
                alt=""
                className="boleto-dda-card-img"
              />
              <p className="boleto-dda-card-text">
                Você não esquece dos pagamentos que precisa fazer.
              </p>
            </div>
            <div className="boleto-dda-card">
              <img
                src="assets/boleto25/ic_checking_account_open.svg"
                alt=""
                className="boleto-dda-card-img"
              />
              <p className="boleto-dda-card-text">Você aceita todos os pagamentos, sem sustos.</p>
            </div>
          </div>
          <WhiteButton
            href="blog/o-que-e-dda.html"
            className="btn-saiba-mais-dda"
            target="_blank"
            rel="noopener"
          >
            Saiba mais
          </WhiteButton>
        </ContainerHome24>
        <img src="assets/boleto25/img-dda.svg" className="img-dda" alt="" />
        <img src="assets/boleto25/img-dda-desk.png" className="img-dda-desk" alt="" />
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25DDA;
